var map = {
	"./50_percent_history.svg": 7016,
	"./CreateOrganization.svg": 58406,
	"./accordion_ic.svg": 11626,
	"./ackowledgment_node.svg": 54330,
	"./ai-assistant-empty-avatar.svg": 2797,
	"./ai-assistant-logo-green.svg": 19351,
	"./ai-assistant-logo.svg": 99768,
	"./ai-assistant-pause-circle.svg": 34434,
	"./ai-assistant-play-circle.svg": 58715,
	"./ai-assistant.svg": 95561,
	"./ai-chat-icon.svg": 59179,
	"./ai-video-icon.svg": 60977,
	"./ai-video-menu-icon.svg": 57337,
	"./ai_assistant_small_ic.svg": 73734,
	"./ai_market.svg": 10766,
	"./alert-triangle.svg": 48000,
	"./analytics_empty_state.svg": 69984,
	"./arrow_lesson_down.svg": 33866,
	"./arrow_supplemental_ic.svg": 17211,
	"./artifact-type-image.svg": 14740,
	"./artifact-type-video.svg": 64296,
	"./assistant_placeholder_ic.svg": 15242,
	"./audio-icon.svg": 86140,
	"./book_active_ic.svg": 69961,
	"./book_ic.svg": 4610,
	"./breadcrum_ic.svg": 78973,
	"./cc_captions.svg": 8012,
	"./changeMedia.svg": 85660,
	"./check-green.svg": 13534,
	"./check.svg": 90191,
	"./check_success_ic.svg": 48289,
	"./choice_branch.svg": 21908,
	"./clear.svg": 72551,
	"./close_faq.svg": 4522,
	"./close_filter_ic.svg": 53829,
	"./close_modal.svg": 63672,
	"./copyIc.svg": 98767,
	"./copy_ic.svg": 34256,
	"./course-card.svg": 39989,
	"./course-hero.svg": 95886,
	"./course-menu.svg": 91705,
	"./course.svg": 5316,
	"./course_action_lesson_icon.svg": 93950,
	"./course_action_time_ic.svg": 91119,
	"./course_ic.svg": 57970,
	"./course_info_divider.svg": 65065,
	"./course_time_ic.svg": 67915,
	"./courses_empty_state.svg": 44948,
	"./delete_ic.svg": 91229,
	"./descktop_icon.svg": 96788,
	"./desktop-learning-menu.svg": 70282,
	"./divider_white_ic.svg": 28823,
	"./document-card.svg": 88929,
	"./dots-horizontal.svg": 80238,
	"./drag_indicator.svg": 20577,
	"./edge_add.svg": 38003,
	"./edit.svg": 6433,
	"./editor_add_audio.svg": 70261,
	"./editor_add_gradable_branch.svg": 99388,
	"./editor_add_item_ic.svg": 12827,
	"./editor_info_ic.svg": 32082,
	"./editor_video_ic.svg": 28159,
	"./exam-icon.svg": 54950,
	"./eye-off.svg": 89632,
	"./eye.svg": 58068,
	"./faq_open.svg": 97689,
	"./feedback-menu.svg": 87983,
	"./folder_ic.svg": 44041,
	"./folder_ic_empty.svg": 88807,
	"./folders_arrow.svg": 48917,
	"./freeform_shape.svg": 809,
	"./gradableIconPlayer.svg": 43067,
	"./gradable_ic.svg": 4154,
	"./gradable_player_ic.svg": 94356,
	"./heart.svg": 19883,
	"./homeActive.svg": 76093,
	"./image_node.svg": 50973,
	"./info_player.svg": 89381,
	"./instructors_market.svg": 56048,
	"./jump_to.svg": 16065,
	"./learner_assistans_empty_state.svg": 38871,
	"./learners_market.svg": 76873,
	"./lesson_arrow_back.svg": 75017,
	"./lesson_blocked_ic.svg": 68882,
	"./lesson_completed_ic.svg": 34651,
	"./lesson_failed_ic.svg": 47133,
	"./lesson_ic.svg": 75687,
	"./lesson_list_play_button_ic.svg": 14880,
	"./lesson_placeholder_ic.svg": 18838,
	"./lessons-icon.svg": 68960,
	"./library_empty_state.svg": 83976,
	"./light_bulb.svg": 46806,
	"./logo-text.svg": 75959,
	"./logo.svg": 47714,
	"./logoTextWhite.svg": 83186,
	"./market_image.svg": 18719,
	"./mchoice_answer_correct_ic.svg": 14387,
	"./mchoice_answer_incorrect_ic.svg": 70303,
	"./mchoice_modal_icon.svg": 68317,
	"./microlesson-menu.svg": 34014,
	"./microlesson.svg": 60742,
	"./microreel-card.svg": 56445,
	"./microreel-hero.svg": 13894,
	"./microreel-menu.svg": 5256,
	"./microreel-source.svg": 1953,
	"./microreel.svg": 14964,
	"./microreel_copy_ic.svg": 83398,
	"./mobile-learning-menu.svg": 87998,
	"./multiple_choice_list_ic.svg": 84201,
	"./music.svg": 96955,
	"./mute-icon.svg": 63356,
	"./not_found_icon.svg": 59190,
	"./number_picker_arrow_down.svg": 57265,
	"./number_picker_arrow_up.svg": 9122,
	"./open-ended-question-icon.svg": 79533,
	"./pause_ic.svg": 42693,
	"./play_circle_icon.svg": 93751,
	"./play_ic.svg": 12900,
	"./posts-menu.svg": 7263,
	"./preview_info.svg": 97523,
	"./projects-menu.svg": 93427,
	"./record-video-icon.svg": 24150,
	"./regenerate-icon.svg": 72102,
	"./rotate-ic.svg": 70370,
	"./sampleTipImageContent.svg": 20244,
	"./scorm_market.svg": 9910,
	"./search.svg": 26904,
	"./settings_title_icon.svg": 35464,
	"./slot-lock.svg": 68070,
	"./sound-file-icon.svg": 4377,
	"./square_background.svg": 72686,
	"./storage_market.svg": 55136,
	"./studio-alert-triangle.svg": 96614,
	"./studio-arrow-down.svg": 4141,
	"./studio-arrow-up.svg": 50878,
	"./studio-captions.svg": 890,
	"./studio-check-circle.svg": 52421,
	"./studio-check.svg": 37079,
	"./studio-chevron-left.svg": 15773,
	"./studio-chevron-right.svg": 40620,
	"./studio-clipboard-check.svg": 39112,
	"./studio-clock.svg": 26257,
	"./studio-download.svg": 32505,
	"./studio-file-text.svg": 50970,
	"./studio-file-video.svg": 45395,
	"./studio-film.svg": 59229,
	"./studio-help-circle.svg": 77114,
	"./studio-image-plus.svg": 71772,
	"./studio-list-checks.svg": 42790,
	"./studio-loader.svg": 84597,
	"./studio-message-square-text.svg": 16234,
	"./studio-panel-left-close.svg": 90711,
	"./studio-panel-left-open.svg": 41220,
	"./studio-pause-filled.svg": 58287,
	"./studio-pencil-line.svg": 99517,
	"./studio-play-filled.svg": 83876,
	"./studio-plus.svg": 65686,
	"./studio-refresh.svg": 94704,
	"./studio-rotate-ccw.svg": 78933,
	"./studio-scissors.svg": 51215,
	"./studio-settings.svg": 69417,
	"./studio-sparkles.svg": 13402,
	"./studio-trash.svg": 12393,
	"./studio-volume-x.svg": 7792,
	"./studio-volume.svg": 97724,
	"./studio-x.svg": 9689,
	"./sub_ai_icon.svg": 11656,
	"./sub_storage_ic.svg": 56204,
	"./sub_users_ic.svg": 29965,
	"./subscriotion_green_check.svg": 36117,
	"./subscription_cross_ic.svg": 71492,
	"./subscription_summary_arrow_back.svg": 73649,
	"./supplemental_arrow_history.svg": 86214,
	"./tab-library.svg": 76278,
	"./tab-storyblocks.svg": 51825,
	"./tapybl-logo.svg": 7162,
	"./text_icon.svg": 78454,
	"./tooltip_arrow.svg": 13679,
	"./trash-icon.svg": 70027,
	"./users_title_icon.svg": 96923,
	"./video-generation-menu.svg": 28219,
	"./video.svg": 69703,
	"./video_ai_processing.svg": 95932,
	"./voice_female_active.svg": 74409,
	"./voice_female_inactive.svg": 39821,
	"./voice_male_active.svg": 89214,
	"./voice_male_inactive.svg": 67970,
	"./workspace_temporal_grade.svg": 94198,
	"./workspace_temporal_image_icon.svg": 81154,
	"./workspace_temporal_learners.svg": 21041,
	"./workspace_temporal_unpublished_eye.svg": 99247,
	"./workspace_temporal_video.svg": 24117,
	"./workspace_temporal_world_icon.svg": 80442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92785;